import React from 'react';
import { Box, Tooltip } from 'wix-style-react';
import withTheme from '../../providers/theme/withTheme';
import withAppMode from '../../providers/appMode/withAppMode';
import { translate } from 'react-i18next';
var _ErrorIndicationStatus = function (_a) {
    var tooltipContent = _a.tooltipContent, messageContent = _a.messageContent, icon = _a.icon;
    return (React.createElement(Box, { dataHook: "error-indication-status", verticalAlign: "top", paddingTop: "4px" },
        icon && (React.createElement(Tooltip, { dataHook: "error-indication-status-tooltip", content: tooltipContent, disabled: !tooltipContent },
            React.createElement(Box, { marginRight: "3px" },
                React.createElement(Box, { cursor: "pointer", height: "16px", marginRight: "3px", align: "center", verticalAlign: "middle", dataHook: "error-indication-status-icon" }, icon)))),
        React.createElement(Box, { dataHook: "error-indication-status-message" }, messageContent)));
};
export var ErrorIndicationStatus = withAppMode(withTheme(translate()(_ErrorIndicationStatus)));
//# sourceMappingURL=ErrorIndicationStatus.js.map